import { Injectable } from '@angular/core';
import { XsrfTokenSource } from './xsrf-token-source.port';

const XSRF_COOKIE_NAME = 'XSRF-TOKEN';

// Cookie read lifted byte-for-byte from
// libs/auth/src/lib/interceptors/xsrf.interceptor.ts (design D5) — web
// behavior must not change. capture() is a no-op: the cookie is
// authoritative on web, set directly by the backend's Set-Cookie.
@Injectable({ providedIn: 'root' })
export class WebXsrfTokenSource implements XsrfTokenSource {
  read(): string | null {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${XSRF_COOKIE_NAME}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  capture(): void {
    // no-op — web always sources the token from document.cookie, never from
    // a captured response-body value.
  }
}
